export const UPLOAD_SONG_REQUEST = "UPLOAD_SONG_REQUEST";
export const UPLOAD_SONG_SUCCESS = "UPLOAD_SONG_SUCCESS";
export const UPLOAD_SONG_ERROR = "UPLOAD_SONG_ERROR";
export const UPLOAD_SONG_RESET = "UPLOAD_SONG_RESET";

export const UPLOAD_IMAGE_REQUEST = "UPLOAD_IMAGE_REQUEST";
export const UPLOAD_IMAGE_ERROR = "UPLOAD_IMAGE_ERROR";
export const UPLOAD_IMAGE_SUCCESS = "UPLOAD_IMAGE_SUCCESS";
